import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

import { useAuthUser } from '@/modules/Auth'

export const useGradeNotification = () => {
  const client = useGyymClient()
  const { isVerified } = useAuthUser()

  return useGyymSWR(
    // Don't fetch if the user isn't logged in
    isVerified ? client.user.me.getGradeNotification : null,
  )
}
